import { useEffect } from 'react'

import { clsx } from 'clsx'
import { Link, useLocation, useOutletContext } from 'react-router'

import { useScrollIntoView } from '~/portal/hooks/useScrollIntoView'
import { DefinitionMarkdownComponentItem } from '~/portal/types/content'
import { RootOutletContext } from '~/portal/types/portal'

export const DefinitionMarkdownSubNavItem = ({
  parentPath,
  componentItem,
  active = false,
  isSelected,
  setSelectedComponentItem,
  onClick,
  expandable = true,
}: {
  parentPath: string,
  componentItem: DefinitionMarkdownComponentItem,
  active?: boolean,
  isSelected: boolean,
  setSelectedComponentItem: (selectedComponentItem: string | null) => void,
  onClick?: (e) => void,
  expandable?: boolean,
}) => {
  const { hash: locationHash } = useLocation()

  const encodedComponentItemId = encodeURIComponent(componentItem.id)
  const isCurrentHash = `#${encodedComponentItemId}` === locationHash

  useEffect(() => {
    if (active && isCurrentHash) {
      setSelectedComponentItem(componentItem.id)
    } else if (!active) {
      setSelectedComponentItem(null)
    }
  }, [active, locationHash, setSelectedComponentItem, componentItem.id])

  const navActiveItemRef = useScrollIntoView<HTMLAnchorElement>()

  const { closeSideNavWithoutTransition } = useOutletContext<RootOutletContext>()

  const onNavigate = (e) => {
    onClick?.(e)
    closeSideNavWithoutTransition?.()
  }

  return (
    <Link to={`${parentPath}#${encodedComponentItemId}`}
      onClick={onNavigate}
      className={clsx(
        'ml-1 flex pr-8 rounded max-w-full overflow-hidden z-40',
        active && 'hover:bg-(--sp-sidenav-item-hover-bg,var(--sp-color-surface-hover))',
        isSelected ? 'bg-(--sp-sidenav-item-active-bg,var(--sp-color-surface-hover)) text-(--sp-color-link) font-semibold' : '',
        expandable ? 'py-1.5 pl-2' : 'pl-6 py-0.5 font-semibold'
      )}
      ref={(active && isCurrentHash) ? navActiveItemRef : null}
    >
      <div className="overflow-hidden break-words">
        {componentItem.title}
      </div>
    </Link>
  )
}
